<template>
	<el-button class="toggle" size="small" type="text" @click="toggle">
		{{ value ? 'Hide Patients' : 'Show Patients' }}
		&nbsp;
		<i class="el-icon " :class="value? 'el-icon-arrow-up': 'el-icon-arrow-down'"></i>
	</el-button>
</template>

<script>
export default {
	name: 'import-table-toggle-rows',

	props: {
		value: {
			type: Boolean,
			required: true
		}
	},

	methods: {
		toggle() {
			this.$emit('input', !this.value)
		}
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
